import React, {Fragment, useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import {useRequest} from "ahooks";
import {useHistory} from "react-router-dom";
import {useForm, useWatch} from "antd/lib/form/Form";
import {useParams} from "react-router";
import * as api from "../../../../apis/platforms/admin/placingInstruments";
import {Card, Col, Divider, Form, Input, InputNumber, message, Row, Space, Switch} from "antd";
import {EditOutlined, PlayCircleOutlined, RollbackOutlined, StopOutlined} from "@ant-design/icons";
import Select from "../../../../components/Select";
import withAuth from "../../../../utils/withAuth";

const EditFragment = withAuth('edit', Fragment)
const StatusFragment = withAuth('status', Fragment)

let hospital: any[] = []

export default function PlacingInstrumentsEdit() {

    const history = useHistory()
    const [form] = useForm()
    const {id} = useParams<any>()
    const [canEdit, setCanEdit] = useState(false)
    const [placingInstrumentsDetail, setPlacingInstrumentsDetail] = useState<any>({})

    useEffect(() => {
        if (id) {
            getPlacingInstrumentsDetail(id)
        } else {
            setCanEdit(true)
        }
    }, [])

    const {run: getPlacingInstrumentsDetail} = useRequest(api.getPlacingInstrumentsDetail, {
        manual: true,
        onSuccess: (res) => {
            const result = res.data.data.specificationAndModel.split("-")
            const last = result.pop()
            res.data.data.sm = result.join("-")
            res.data.data.smDate = last
            setPlacingInstrumentsDetail(res.data.data)
            form.setFieldsValue(res.data.data)
        }
    })

    const {run: switchStatus} = useRequest(api.switchStatus, {
        manual: true,
        onSuccess(res) {
            message.success("操作成功")
            getPlacingInstrumentsDetail(id)
        }
    })

    const {
        loading: submitPlacingInstrumentsLoading,
        run: submitPlacingInstruments
    } = useRequest(api.modifyPlacingInstruments, {
        manual: true,
        onSuccess(res) {
            message.success("操作成功")
            setCanEdit(false)
        }
    })

    function doSubmit() {
        form.validateFields().then((values) => {
            submitPlacingInstruments(values)
        })
    }

    function generateFullName() {
        const hospitalId = form.getFieldValue("hospitalId")
        const hospitalName = hospital.filter((i) => i.id === hospitalId)[0].name
        const barcode = form.getFieldValue("barcode")
        // const specificationAndModel = form.getFieldValue("specificationAndModel")

        const sm = form.getFieldValue("sm")
        const smDate = form.getFieldValue("smDate")

        const v = [hospitalName, barcode ? '条码' : '非条码', sm, smDate].filter(i => i).join("-")
        form.setFieldValue('hospitalInstrumentsFullName', v)
        form.setFieldValue('specificationAndModel', [sm, smDate].filter(i => i).join("-"))
    }

    return (
        <PageHeaderLayout withFooterBar={canEdit}
                          onOk={doSubmit}
                          onCancel={() => setCanEdit(false)}
                          btnLoading={submitPlacingInstrumentsLoading}
        >
            <Card title={'基本信息'} extra={
                <Space split={<Divider type="vertical"/>} style={{fontWeight: "bold"}}>
                    {id &&
                        <>
                            <EditFragment>
                                <a onClick={() => setCanEdit(true)}><EditOutlined/> 修改</a>
                            </EditFragment>
                            <StatusFragment>
                                {!placingInstrumentsDetail.status ?
                                    <a onClick={() => switchStatus(id)}><PlayCircleOutlined/> 启用</a>
                                    :
                                    <a onClick={() => switchStatus(id)}><StopOutlined/> 停用</a>
                                }
                            </StatusFragment>
                        </>
                    }
                    <a onClick={() => history.replace(`/product/placingInstruments/`)}><RollbackOutlined/> 返回</a>
                </Space>
            }>
                <Form
                    disabled={!canEdit}
                    form={form}
                    labelCol={{span: 5}}
                >
                    <Form.Item name={'id'} noStyle>
                        <Input style={{display: 'none'}}/>
                    </Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="客户"
                                name="dealerId"
                                rules={[{required: true, message: '请选择客户'}]}
                            >
                                <Select style={{width: '100%'}}
                                        url={'/dealer/dict'}
                                        getData={data => data.data}
                                        textField={'name'}
                                        valueField={'id'}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="医院"
                                name="hospitalId"
                                rules={[{required: true, message: '请选择医院'}]}
                            >
                                <Select style={{width: '100%'}}
                                        url={'/hospital/dict'}
                                        getData={data => {
                                            hospital = data.data
                                            return data.data
                                        }}
                                        textField={'name'}
                                        onChange={generateFullName}
                                        valueField={'id'}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="是否条形码产品"
                                name="barcode"
                                initialValue={true}
                                valuePropName={'checked'}
                            >
                                <Switch onChange={generateFullName}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="规格型号-有效期"
                                name="specificationAndModel"
                                // rules={[{required: true, message: '请填写规格型号'}]}
                            >
                                <Input disabled={true}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="规格型号"
                                name="sm"
                                rules={[{required: true, message: '请填写规格型号'}]}
                            >
                                <Input onChange={generateFullName}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="有效期"
                                name="smDate"
                                rules={[{required: true, message: '请填写有效期'}]}
                            >
                                <Input onChange={generateFullName}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="医院仪器全称"
                                name="hospitalInstrumentsFullName"
                            >
                                <Input disabled={true}/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="品牌"
                                name="brand"
                            >
                                <Input/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="保修年限"
                                name="guaranteePeriod"
                            >
                                <InputNumber style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </PageHeaderLayout>
    )
}
